import { TenantPermission } from '@tabeeb/contracts/main-api/swagger-main-api'
import { getIsAIReportEnabled } from '@tabeeb/modules/appConfigState/selectors'
import { hasTenantPermission } from '@tabeeb/modules/permissions/selectors'
import { RootState } from '@tabeeb/store'
import { createSelector, Selector } from 'reselect'

export const getIsAIReportDialogOpen = (state: RootState) => state.AIReport.isOpen
export const getAIReportAiObjects = (state: RootState) => state.AIReport.aiObjects
export const getAIReport = (state: RootState) => state.AIReport.analysis

export const getSelectedAiObjectId = (state: RootState) => state.AIReport.selectedAiObject.aiObjectId

export const getSelectedTemplate = (state: RootState) => state.AIReport.selectedTemplate

export const getAreAIObjectsLoading = (state: RootState) => state.AIReport.areObjectsLoading
export const getIsAnalysisLoading = (state: RootState) => state.AIReport.isAnalysisLoading

export const getTemplates = (state: RootState) => state.AIReport.publishTemplates
export const getIsRefreshNeeded = (state: RootState) => state.AIReport.isRefreshNeeded

export const getIsPublishSettingsDialogOpen = (state: RootState) => state.AIReport.isPublishSettingsDialogOpen
export const getDefaultPublishNameSelector = (state: RootState) => state.AIReport.defaultPublishName
export const getIsUniqueNameCheckInProgress = (state: RootState) => state.AIReport.isUniqueNameCheckInProgress
export const getIsPublishInProgress = (state: RootState) => state.AIReport.isPublishInProgress

export const getHasAIReportAccess: Selector<RootState, boolean> = createSelector(
  getIsAIReportEnabled,
  (state: RootState) => hasTenantPermission(state, TenantPermission.InventoryAnalysis),
  (enabledOnTenant, hasPermission) => {
    return enabledOnTenant && hasPermission
  }
)
